const getCardDetailsReducer = (state = { cardDetailState: [] }, action) => {
    switch (action.type) {
        case "CARD_DETAILSTATE":
            return {
                cardDetailState: action.cardDetailState,
            }

        default:
            return state;
    }
}

export default getCardDetailsReducer;


// WEBPACK FOOTER //
// ./src/reducer/carddetails.jsx